import React, { useState } from 'react';

const AddBookingForm = ({ mockData, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    patientName: '',
    patientEmail: '',
    patientPhone: '',
    practitioner: '',
    service: '',
    location: '',
    date: '',
    time: '',
    notes: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="add-booking-form">
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label className="form-label">Patient Name *</label>
            <input
              type="text"
              name="patientName"
              className="form-input"
              value={formData.patientName}
              onChange={handleChange}
              required
              placeholder="John Doe"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Patient Email *</label>
            <input
              type="email"
              name="patientEmail"
              className="form-input"
              value={formData.patientEmail}
              onChange={handleChange}
              required
              placeholder="john.doe@email.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Patient Phone</label>
            <input
              type="tel"
              name="patientPhone"
              className="form-input"
              value={formData.patientPhone}
              onChange={handleChange}
              placeholder="+44 7123 456789"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Practitioner *</label>
            <select
              name="practitioner"
              className="form-input"
              value={formData.practitioner}
              onChange={handleChange}
              required
            >
              <option value="">Select practitioner</option>
              <option value="Dr. Lisa Chen">Dr. Lisa Chen</option>
              <option value="Dr. John Smith">Dr. John Smith</option>
              <option value="Dr. Priya Patel">Dr. Priya Patel</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Service *</label>
            <select
              name="service"
              className="form-input"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="">Select service</option>
              <option value="Physiotherapy">Physiotherapy</option>
              <option value="Sports Massage">Sports Massage</option>
              <option value="Osteopathy">Osteopathy</option>
              <option value="Consultation">Consultation</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Location *</label>
            <select
              name="location"
              className="form-input"
              value={formData.location}
              onChange={handleChange}
              required
            >
              <option value="">Select location</option>
              <option value="harley-street">Harley Street</option>
              <option value="canary-wharf">Canary Wharf</option>
              <option value="kensington">Kensington</option>
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Date *</label>
            <input
              type="date"
              name="date"
              className="form-input"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Time *</label>
            <select
              name="time"
              className="form-input"
              value={formData.time}
              onChange={handleChange}
              required
            >
              <option value="">Select time</option>
              <option value="09:00">09:00 AM</option>
              <option value="10:00">10:00 AM</option>
              <option value="11:00">11:00 AM</option>
              <option value="14:00">02:00 PM</option>
              <option value="15:00">03:00 PM</option>
              <option value="16:00">04:00 PM</option>
            </select>
          </div>

          <div className="form-group" style={{ gridColumn: '1 / -1' }}>
            <label className="form-label">Notes</label>
            <textarea
              name="notes"
              className="form-input"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              placeholder="Additional notes or requirements..."
            />
          </div>
        </div>

        <div className="form-actions" style={{ marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
          >
            Create Appointment
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddBookingForm;